import * as StoreUtil from '../util/InClientStoreUtil';
import EnableAppDataRequest from 'owa-service/lib/contract/EnableAppDataRequest';
import enableAppDataRequestFactory from 'owa-service/lib/factory/enableAppDataRequest';
import EnableAppDataResponse from 'owa-service/lib/contract/EnableAppDataResponse';
import enableAppOperation from 'owa-service/lib/operation/enableAppOperation';
import Identity from 'owa-service/lib/contract/Identity';
import { createOverrideOptions } from '../util/InClientStoreHelper';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { loadExtensibilityContext } from 'owa-addins-boot';
import { setExtensibilityContext, setExtensibilityStateIsDirty } from 'owa-addins-store';

import ServiceEndpoint = OSF.ServiceEndpoint;

export function registerMethod(serviceEndPoint: ServiceEndpoint) {
    serviceEndPoint.registerMethod(
        'EnableApp',
        (data: any, responseMethod: Function) => {
            EnableApp(data)
                .then(response => {
                    responseMethod([response.WasSuccessful], 0);

                    loadExtensibilityContext().then(context => {
                        setExtensibilityContext(context);
                        setExtensibilityStateIsDirty(true);
                    });
                })
                .catch(reason => {
                    if (reason.ErrorMessage) {
                        responseMethod([reason.ErrorMessage], -1);
                    } else {
                        responseMethod([], -1);
                    }
                });
        },
        Microsoft.Office.Common.InvokeType.async,
        false /* isBlocking */
    );
}

function EnableApp(data: any): Promise<EnableAppDataResponse> {
    const IdentityBody: Identity = {
        DisplayName: data[0],
        RawIdentity: data[1],
    };

    const Body: EnableAppDataRequest = {
        Header: getJsonRequestHeader(StoreUtil.getUserTimeZone()),
        Identity: IdentityBody,
    };

    const enableRequest: EnableAppDataRequest = enableAppDataRequestFactory(Body);
    const fetchOptions = createOverrideOptions();

    return enableAppOperation(enableRequest, fetchOptions);
}
